export enum ESortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type TSortOrder = `${ESortOrder}` | undefined;
